import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/ui/collapsible";
import { useState } from "react";
import { useLocation } from "react-router";
import type { NavListProps } from "../types";
import { NavItem } from "./nav-item";

export function NavList({ data, depth = 1, onNavigate }: NavListProps) {
	const location = useLocation();
	const hasChild = data.children && data.children.length > 0;
	const isActive = hasChild
		? location.pathname === data.path || location.pathname.startsWith(data.path + "/")
		: location.pathname === data.path;
	const [open, setOpen] = useState(isActive);

	const handleClick = () => {
		if (hasChild) {
			setOpen(!open);
		} else {
			// If no children, it's a navigation link - close the menu
			onNavigate?.();
		}
	};

	if (data.hidden) {
		return null;
	}

	return (
		<Collapsible open={open} onOpenChange={setOpen} data-nav-type="list">
			<CollapsibleTrigger className="w-full">
				<NavItem
					// data
					title={data.title}
					path={data.path}
					icon={data.icon}
					info={data.info}
					caption={data.caption}
					auth={data.auth}
					// state
					open={open}
					active={isActive}
					disabled={data.disabled}
					// options
					hasChild={hasChild}
					depth={depth}
					// event
					onClick={handleClick}
					onNavigate={onNavigate}
				/>
			</CollapsibleTrigger>
			{hasChild && (
				<CollapsibleContent>
					<div className="ml-4 mt-1 flex flex-col gap-1">
						{data.children?.map((child) => (
							<NavList key={child.title} data={child} depth={depth + 1} onNavigate={onNavigate} />
						))}
					</div>
				</CollapsibleContent>
			)}
		</Collapsible>
	);
}
